import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '重庆市2022年公益广告大赛';
const baseUrl = '20220919GYGGTP';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    // {
    //   path: 'home',
    //   name: `${baseUrl}-home`,
    //   component: () => import('./pages/Home.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    // {
    //   path: 'plane',
    //   name: `${baseUrl}-plane`,
    //   component: () => import('./pages/Plane.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    {
      path: 'video',
      name: `${baseUrl}-video`,
      component: () => import('./pages/Video.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    // {
    //   path: 'interaction',
    //   name: `${baseUrl}-interaction`,
    //   component: () => import('./pages/Interaction.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    // {
    //   path: 'homeDetail',
    //   name: `${baseUrl}-homeDetail`,
    //   component: () => import('./pages/HomeDetail.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    // {
    //   path: 'planeDetail',
    //   name: `${baseUrl}-planeDetail`,
    //   component: () => import('./pages/PlaneDetail.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    {
      path: 'videoDetail',
      name: `${baseUrl}-videoDetail`,
      component: () => import('./pages/VideoDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    // {
    //   path: 'interactionDetail',
    //   name: `${baseUrl}-interactionDetail`,
    //   component: () => import('./pages/InteractionDetail.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    // {
    //   path: 'rule',
    //   name: `${baseUrl}-rule`,
    //   component: () => import('./pages/Rule.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
  ],
};

export default route;
